import { useEffect } from "react";
import { api } from "../lib/api";

// Polls reminders and fires browser notifications when the local time matches.
// Stores last-fired keys in localStorage to avoid duplicates within the same minute.
export default function ReminderRunner() {
  useEffect(() => {
    let cancelled = false;
    let interval;

    const check = async () => {
      try {
        if (typeof Notification === "undefined" || Notification.permission !== "granted") return;
        const { data } = await api.get("/reminders");
        if (cancelled) return;
        const now = new Date();
        const hhmm = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
        const today = now.getDay(); // 0=Sun..6=Sat
        const stampKey = "sh_reminder_fired";
        const fired = JSON.parse(localStorage.getItem(stampKey) || "{}");
        for (const r of data) {
          if (!r.enabled) continue;
          if (!r.days?.includes(today)) continue;
          if (r.time_of_day !== hhmm) continue;
          const k = `${r.id}:${now.toISOString().slice(0, 16)}`; // unique per minute
          if (fired[k]) continue;
          new Notification("SafeHaven · " + r.title, {
            body: "Gentle nudge for your check-in or self-care.",
            tag: r.id,
          });
          fired[k] = Date.now();
        }
        // prune fired entries older than 2 minutes
        const cutoff = Date.now() - 2 * 60 * 1000;
        for (const k of Object.keys(fired)) {
          if (fired[k] < cutoff) delete fired[k];
        }
        localStorage.setItem(stampKey, JSON.stringify(fired));
      } catch (err) {
        // Reminder check runs every 30s — log so silent failures don't go unnoticed during dev,
        // without producing a toast on every tick.
        console.debug("ReminderRunner tick failed", err);
      }
    };

    check();
    interval = setInterval(check, 30 * 1000);
    return () => { cancelled = true; clearInterval(interval); };
  }, []);

  return null;
}
